import React, { ReactNode, useEffect, useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import {
  Datagrid,
  Labeled,
  ListContextProvider,
  TextField,
  useDataProvider,
  useList,
} from "react-admin";
import CustomPagination from "../../../components/CustomPagination";

interface INotificationReceiverReferenceField {
  sourceField: string;
  sourceIds: number[];
  labelField: string;
  labelSourceField: string;
  pageSize?: number;
  orderBy?: string;
  orderType?: "ASC" | "DESC";
  children?: ReactNode;
}

const useStyles = makeStyles({
  thead: {
    display: "none",
  },
});

const NotificationReceiverReferenceField = ({
  sourceField,
  sourceIds,
  labelField,
  labelSourceField,
  children,
  pageSize = 10,
  orderBy = "id",
  orderType = "DESC",
}: INotificationReceiverReferenceField) => {
  const classes = useStyles();
  const provider = useDataProvider();
  const [dataSource, setDataSource] = useState([]);
  const listContext = useList({
    data: dataSource,
    ids: sourceIds || [],
    loaded: true,
    loading: false,
    perPage: pageSize,
    sort: { field: orderBy, order: orderType },
  });

  useEffect(() => {
    if (sourceIds && sourceIds.length > 0) {
      provider.getMany(sourceField, { ids: sourceIds }).then((result) => {
        setDataSource(result.data);
      });
    }
  }, [sourceIds]);

  return (
    <Labeled source={labelField}>
      <ListContextProvider value={listContext}>
        <Datagrid classes={{ thead: classes.thead }}>
          {children ? (
            children
          ) : (
            <TextField source={labelSourceField} label="" />
          )}
        </Datagrid>
        <CustomPagination limit={<Typography variant="body2">-</Typography>} />
      </ListContextProvider>
    </Labeled>
  );
};

export default NotificationReceiverReferenceField;
